import { useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { TNullable } from '@/shared/types';
import { classNames } from '@/shared/lib/classNames';
import { setCookie } from '@/shared/lib/utils/setCookie';
import Logout from '@/shared/assets/lk/logout.svg?react';
import { ClickAwayListener, Menu, MenuItem } from '@mui/material';
import Second from '@/shared/assets/logout_button/Exit.svg?react';
import { useLogin, useLogout, useUserStore } from '@/entities/User';
import Third from '@/shared/assets/logout_button/Arrow_Reload_02.svg?react';
import First from '@/shared/assets/logout_button/Arrow_Undo_Up_Left.svg?react';
import cls from './LogoutButton.module.scss';

type Props = {
    className?: string;
};

export const LogoutButton = ({ className }: Props) => {
    const { cleanupUserStore } = useUserStore();
    const reason = useRef<TNullable<'change' | 'leave'>>(null);
    const [anchorEl, setAnchorEl] = useState<TNullable<HTMLElement>>(null);

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { mutate: login } = useLogin();
    const { mutate: logout } = useLogout({
        onSuccess: () => {
            setAnchorEl(null);

            if (reason.current && reason.current === 'change') {
                setCookie('search_params', searchParams.toString(), 1);
                login();
            }

            if (reason.current && reason.current === 'leave') {
                navigate('/');
                cleanupUserStore();
            }
        },
    });

    const handleMenuClick = (event: { currentTarget: HTMLElement }) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    const handleClickAway = () => {
        if (open) {
            setAnchorEl(null);
        }
    };

    const MENU_ITEMS = [
        {
            title: 'Вернуться на Информационный лендинг',
            icon: First,
            handler: () => {
                navigate('/');
            },
        },
        {
            title: 'Выйти из  личного кабинета',
            icon: Second,
            handler: () => {
                reason.current = 'leave';
                logout();
            },
        },
        {
            title: 'Сменить пользователя',
            icon: Third,
            handler: () => {
                reason.current = 'change';
                logout();
            },
        },
    ];

    return (
        <ClickAwayListener disableReactTree onClickAway={handleClickAway}>
            <div>
                <button className={classNames(cls.button, {}, [className])} type="button" onClick={handleMenuClick}>
                    <Logout />
                </button>
                <Menu
                    className={cls.menu}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    open={open}
                    anchorEl={anchorEl}
                    disableScrollLock
                    onClose={handleMenuClose}
                >
                    {MENU_ITEMS.map((el) => {
                        const { title, icon: Icon, handler } = el;

                        return (
                            <MenuItem className={cls.listItem} key={title} onClick={handler}>
                                <div className={cls.container}>
                                    <Icon />
                                    <span>{title}</span>
                                </div>
                            </MenuItem>
                        );
                    })}
                </Menu>
            </div>
        </ClickAwayListener>
    );
};
